import { TESTIMONIALS } from "@/data/content";
import { Quote } from "lucide-react";

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-28 md:py-36 px-6 sm:px-10 lg:px-16"
    >
      <div className="mx-auto max-w-7xl">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-16">
          <div className="lg:col-span-7">
            <div className="text-xs font-sans tracking-[0.22em] uppercase text-zinc-500 overline-line">
              Stories from the Circle
            </div>
            <h2 className="mt-6 font-serif text-4xl sm:text-5xl md:text-6xl font-light leading-[1.05] text-white">
              Words from the souls <br />
              <span className="italic text-rainbow">who came home to themselves.</span>
            </h2>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <figure
              key={t.id}
              data-testid={`testimonial-${t.id}`}
              className={`relative bg-brand-surface border border-brand-border p-8 md:p-10 rounded-2xl hover-lift ${
                i === 1 ? "md:translate-y-6" : ""
              }`}
            >
              <Quote
                className="text-brand-gold/40 absolute -top-3 left-8"
                size={42}
                strokeWidth={1}
                fill="currentColor"
              />
              <blockquote className="mt-4 font-serif text-xl leading-relaxed text-white/90">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-7 flex items-center gap-4 pt-6 border-t border-brand-border">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="h-12 w-12 rounded-full object-cover ring-1 ring-white/10"
                />
                <div>
                  <div className="text-white font-medium">{t.name}</div>
                  <div className="text-xs text-zinc-500 tracking-wide mt-0.5">{t.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
